import { z } from 'zod'

export type AttributesImage = {
  activeSrc?: string
  src: string
  darkModeSrc?: string
  width?: number
  height?: number
  alt?: string
  caption?: string
  href?: string
  size?: string
  isTipTap?: boolean
}

export const attributesImageSchema = z.object({
  src: z.string(),
  darkModeSrc: z.string().optional(),
  width: z.coerce.number().min(0).optional(),
  height: z.coerce.number().min(0).optional(),
  alt: z.string().optional(),
  caption: z.string().optional(),
  href: z.string().optional(),
  size: z.enum(['actual', 'custom', 'full']).default('actual'),
  isTipTap: z.boolean().optional(),
}) satisfies z.ZodType<AttributesImage>
